import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaititelanganacab() {



    const cardData = {

keyword: "Mumbai to Telangana Cab Service",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Telangana Cab Service for long-distance intercity travel, business trips, family tours, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup in Mumbai, and safe highway driving across Maharashtra and Telangana routes, we ensure a smooth, comfortable, and hassle-free travel experience to major cities in Telangana.",

topPlaces: [
    {
        title: "Hyderabad Charminar",
        description:
            "Charminar is the iconic symbol of Hyderabad known for its historic architecture, bustling markets, and rich cultural heritage, making it a must-visit destination for travelers from Mumbai."
    },
    {
        title: "Golconda Fort",
        description:
            "Golconda Fort is a historic fortress known for its grand architecture, acoustics, and panoramic views of Hyderabad city, attracting history lovers and tourists alike."
    },
    {
        title: "Hussain Sagar Lake",
        description:
            "Hussain Sagar Lake is a famous heart-shaped lake in Hyderabad known for boating activities, evening views, and the Buddha statue located at its center."
    },
    {
        title: "Ramoji Film City",
        description:
            "Ramoji Film City is one of the world’s largest film studio complexes offering entertainment zones, film sets, and attractions for families and tourists."
    },
    {
        title: "Warangal Fort",
        description:
            "Warangal Fort is a historic monument known for its stone architecture, ancient ruins, and cultural importance in Telangana’s history."
    },
    {
        title: "Ramappa Temple",
        description:
            "Ramappa Temple is a UNESCO World Heritage Site known for its intricate carvings and stunning Kakatiya architecture."
    },
    {
        title: "Nagarjuna Sagar Dam",
        description:
            "Nagarjuna Sagar Dam is one of the largest dams in India offering scenic views, boating, and a peaceful environment surrounded by hills."
    },
    {
        title: "Bhadrachalam",
        description:
            "Bhadrachalam is a major pilgrimage destination dedicated to Lord Rama located on the banks of the Godavari River, attracting devotees from across India."
    },
    {
        title: "Kuntala Waterfalls",
        description:
            "Kuntala Waterfalls is the highest waterfall in Telangana, known for its natural beauty, greenery, and monsoon attraction."
    },
    {
        title: "Medak Cathedral",
        description:
            "Medak Cathedral is one of the largest churches in India known for its impressive architecture and peaceful spiritual atmosphere."
    }
],



services: [
{
name: "Mumbai to Telangana Cab Service",
description: "Mumbai Airport Cab offers Mumbai to Telangana Cab Service for safe, comfortable, and reliable long-distance travel between Maharashtra and Telangana. Whether you are travelling for business meetings, family visits, tourism, relocation, or personal trips, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Kia Carens, Tempo Traveller, and luxury cars. Our professional chauffeurs are experienced in long highway routes, ensuring smooth driving, timely pickup, passenger safety, and stress-free journey experience. With doorstep pickup from Mumbai, flexible travel planning, transparent pricing, luggage assistance, and 24x7 support, we make intercity travel comfortable and dependable."
},
{
name: "Mumbai to Telangana Cab",
description: "Mumbai to Telangana Cab service by Mumbai Airport Cab ensures reliable intercity transportation with clean, air-conditioned vehicles and experienced chauffeurs. Ideal for families, corporate travellers, and tourists, we provide flexible pickup options, safe highway driving, and comfortable seating for a smooth journey from Mumbai to any city in Telangana."
},
{
name: "Mumbai to Telangana Taxi",
description: "Mumbai to Telangana Taxi service provides dependable long-distance travel with professional drivers and well-maintained vehicles. Mumbai Airport Cab ensures punctual pickup, safe highway routes, and comfortable journey experience for all passengers travelling between Mumbai and Telangana."
},
{
name: "Mumbai to Telangana Car Rental",
description: "Mumbai Airport Cab offers Mumbai to Telangana Car Rental service with chauffeur-driven vehicles suitable for long-distance travel. Our fleet includes sedans and spacious SUVs designed for comfort, luggage space, and smooth ride quality. We ensure flexible itineraries and safe travel for families and business travellers."
},
{
name: "Mumbai to Telangana One Way Cab",
description: "Mumbai to Telangana One Way Cab service provides cost-effective transportation for passengers who require a single journey without return charges. Mumbai Airport Cab ensures transparent pricing, professional drivers, and comfortable vehicles for relocation, business travel, and intercity trips."
},
{
name: "Mumbai to Telangana Outstation Cab",
description: "Mumbai to Telangana Outstation Cab service offers reliable long-distance travel with well-maintained vehicles and experienced chauffeurs. Mumbai Airport Cab ensures safe highway driving, flexible travel schedules, and comfortable seating for stress-free intercity journeys."
},
{
name: "Mumbai to Telangana Taxi Service",
description: "Mumbai Airport Cab provides Mumbai to Telangana Taxi Service with clean vehicles, professional chauffeurs, and 24x7 availability. We ensure timely pickup, smooth highway travel, and reliable transportation for families, tourists, and corporate travellers."
},
{
name: "Mumbai to Telangana Long Distance Cab",
description: "Mumbai to Telangana Long Distance Cab service is designed for extended highway journeys with maximum comfort and safety. Mumbai Airport Cab offers experienced drivers, air-conditioned vehicles, luggage assistance, and smooth travel planning for long intercity trips."
},
{
name: "Mumbai to Telangana Innova Cab",
description: "Mumbai Airport Cab offers Mumbai to Telangana Innova Cab service for families and groups needing spacious and comfortable travel. Our Innova vehicles provide ample seating, luggage space, and smooth ride quality, making long-distance travel more relaxing and convenient."
},
{
name: "Mumbai to Telangana SUV Cab",
description: "Mumbai to Telangana SUV Cab service provides powerful and comfortable vehicles suitable for long highway journeys. Mumbai Airport Cab ensures safe driving, spacious interiors, and smooth ride experience for group and family travel."
},
{
name: "Mumbai to Telangana Round Trip Cab",
description: "Mumbai to Telangana Round Trip Cab service offers complete return journey solutions for business trips, family travel, tourism, and personal visits. Mumbai Airport Cab ensures flexible scheduling, professional chauffeurs, and comfortable vehicles for a seamless round trip experience."
},
{
name: "Mumbai to Telangana Family Cab",
description: "Mumbai to Telangana Family Cab service provides safe and comfortable transportation for families travelling together. Mumbai Airport Cab ensures spacious vehicles, experienced drivers, luggage-friendly travel, and flexible booking options for a stress-free family journey."
},
{
name: "Mumbai to Telangana Business Cab",
description: "Mumbai to Telangana Business Cab service is designed for corporate professionals requiring reliable transportation for meetings, conferences, and office visits. Mumbai Airport Cab ensures punctual service, executive comfort, and professional chauffeurs for productive business travel."
},
{
name: "Mumbai to Telangana Night Travel Cab",
description: "Mumbai to Telangana Night Travel Cab service provides safe and reliable overnight transportation for long-distance travellers. Mumbai Airport Cab ensures experienced drivers, secure travel conditions, and comfortable vehicles for peaceful night journeys."
},
{
name: "Mumbai to Telangana Highway Cab",
description: "Mumbai to Telangana Highway Cab service ensures safe and efficient long-distance travel across major highway routes. Mumbai Airport Cab provides professional chauffeurs, optimized routes, and well-maintained vehicles for smooth intercity journeys."
},
{
name: "Mumbai to Telangana Intercity Cab",
description: "Mumbai to Telangana Intercity Cab service offers dependable transportation between Mumbai and cities across Telangana. Mumbai Airport Cab ensures safe travel, professional drivers, and comfortable vehicles for seamless intercity journeys."
},
{
name: "Mumbai to Telangana Budget Cab",
description: "Mumbai to Telangana Budget Cab service provides economical travel solutions without compromising safety or comfort. Mumbai Airport Cab ensures affordable pricing, clean vehicles, and reliable drivers for cost-effective long-distance travel."
},
{
name: "Mumbai to Telangana Premium Cab",
description: "Mumbai to Telangana Premium Cab service offers luxury vehicles with high-end comfort for VIP travel, corporate executives, and special occasions. Mumbai Airport Cab ensures premium interiors, professional chauffeurs, and smooth travel experience."
},
{
name: "Mumbai to Telangana Travel Service",
description: "Mumbai to Telangana Travel Service provides complete transportation solutions for families, tourists, and business travellers. Mumbai Airport Cab ensures safe, comfortable, and well-organized intercity travel with flexible itineraries and professional drivers."
}
],

tableData: [
["Mumbai to Telangana Cab Service","Mumbai to Telangana Cab"],
["Mumbai to Telangana Taxi","Mumbai to Telangana Car Rental"],
["Mumbai to Telangana One Way Cab","Mumbai to Telangana Outstation Cab"],
["Mumbai to Telangana Taxi Service","Mumbai to Telangana Long Distance Cab"],
["Mumbai to Telangana Innova Cab","Mumbai to Telangana SUV Cab"],
["Mumbai to Telangana Round Trip Cab","Mumbai to Telangana Family Cab"],
["Mumbai to Telangana Business Cab","Mumbai to Telangana Night Travel Cab"],
["Mumbai to Telangana Highway Cab","Mumbai to Telangana Intercity Cab"],
["Mumbai to Telangana Budget Cab","Mumbai to Telangana Premium Cab"]
],













whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Telangana Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Telangana Cab Services for business travelers, families, corporate professionals, students, tourists, and long-distance travelers."
    },
    {
        WhyChooseheading: "Comfortable Interstate Travel Experience",
        WhyChoosedescription: "Our cab service offers safe and convenient transportation from Mumbai to Hyderabad, Warangal, Karimnagar, Nizamabad, Khammam, Adilabad, and other cities across Telangana."
    },
    {
        WhyChooseheading: "Perfect for Business and Corporate Travel",
        WhyChoosedescription: "Many professionals and corporate clients travel between Mumbai and Telangana for business meetings, IT projects, industrial visits, conferences, and official assignments."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Available",
        WhyChoosedescription: "Whether you need a one-way transfer, round trip, multi-city journey, or customized travel itinerary, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Pickup Available Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, Powai, and surrounding locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Long-Distance Routes",
        WhyChoosedescription: "Our professional chauffeurs are experienced in interstate highway travel and ensure safe, comfortable, and hassle-free transportation."
    },
    {
        WhyChooseheading: "Suitable for Families, Corporate Teams, and Groups",
        WhyChoosedescription: "From solo travelers and families to business teams and tourist groups, we provide suitable vehicle options for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "Which Telangana destinations can I travel to from Mumbai?",
        answer: "Customers can book cabs to Hyderabad, Warangal, Karimnagar, Nizamabad, Khammam, Adilabad, Siddipet, Mahabubnagar, and other destinations across Telangana."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Telangana?",
        answer: "Yes, one-way cab services are available along with round-trip and customized interstate travel packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai to Telangana travel?",
        answer: "Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and travel preferences."
    },
    {
        question: "Do you provide Hyderabad airport transfers from Mumbai?",
        answer: "Yes, customers can book direct cab services from Mumbai to Hyderabad Airport and other Telangana locations."
    },
    {
        question: "Can corporate travelers use this service regularly?",
        answer: "Yes, many IT professionals, business executives, industrial visitors, and corporate clients regularly use our Mumbai to Telangana cab services."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family tours, business groups, educational trips, and corporate teams."
    },
    {
        question: "Can I get pickup from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, railway stations, hotels, offices, and residential locations."
    },
    {
        question: "Can multiple cities in Telangana be covered during the trip?",
        answer: "Yes, customers can customize their itinerary and include multiple Telangana cities, tourist attractions, business locations, and personal stops."
    },
    {
        question: "Is advance booking recommended for Mumbai to Telangana travel?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle and ensure smooth travel planning."
    },
    {
        question: "How can I book a Mumbai to Telangana Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rajesh Kumar",
        feedback:
            "Our business trip from Mumbai to Hyderabad was managed professionally. The vehicle was comfortable, the driver was experienced, and the entire journey was smooth and well-organized.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sneha Reddy",
        feedback:
            "We booked a cab for family travel across Telangana and were extremely satisfied with the service. The vehicle was spacious, clean, and the driver was very courteous throughout the trip.",
        rating: 5
    }
];




































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Telangana Cab Service",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-telangana-cab-service.jpg",
"description": "Book Mumbai to Telangana cab service for long-distance travel, outstation trips, business journeys, and family travel. Mumbai Airport Cabs offers reliable one-way and round-trip taxi service with professional drivers, comfortable vehicles, and 24x7 availability.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-telangana-cab-service"
}
};






    return (
        <div>

<Helmet>
  <title>Mumbai to Telangana Cab Service | Long Distance Taxi | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Telangana cab service for long-distance travel, business trips, and family journeys. Reliable outstation taxi service with professional drivers, safe vehicles, and 24x7 availability."
/>

<meta
 name="keywords"
 content="mumbai to telangana cab service, mumbai to telangana cab, mumbai to telangana taxi, mumbai to telangana car rental, mumbai to telangana one way cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/51.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaititelanganacab;